<div class="my-delegations-tab">
    <div id="my-delegations-tab-panel-list" *ngIf="!loader">
      <app-delegation-panel-list
      [showLoader] = "showPanelLoader"
      [myDelegationsData]="myDelegationsData"
      [isDelegateFromDisplayed]="false"
      [isDelegateToDisplayed]="true"
      [isInActiveSelected]="isActiveDelegates"
      (showInactiveDelegates)="showInactiveDelegates()"
      (selectedDelegates)="selectedDelegates($event)">
    </app-delegation-panel-list>

    <div class="btnClass" *ngIf="myDelegationsData?.lists?.length>0 && !loader">
    <p-button
    appPreventDoubleClick
          styleClass="p-button-outlined"
          label="{{delegationReassignTitle}}"
          id="reassignDelegateButton"
          class="reassign-delegate-button"
          icon="fa fa-recycle"
          iconPos="left"
          [disabled]="isConfirmBtnDisable" 
          (debounceClick)="reassignDelegation()"
        ></p-button>

        <p-button
        appPreventDoubleClick
        styleClass="p-button-outlined"
        label="{{delegationEndTitle}}"
        id="endDelegateButton"
        class="end-delegate-button"
        icon="fa fa-stop-circle"
        iconPos="left"
        [disabled]="isConfirmBtnDisable"
        (debounceClick)="endDelegationConfirmation()"
      ></p-button>
    </div>

    <p-dialog [(visible)]="isModalVisable" [style]="{width: '35vw'}" [modal]="true" >
      <ng-template pTemplate="header">
          <b>{{PopupHeader}}</b>
      </ng-template>
      <p class="dialogText">{{PopupText}}</p>
      <div *ngIf="isDelegateRequired">
        <p-messages severity="error">
          <ng-template pTemplate>              
                <span>{{delegateToValidationText}}</span>              
          </ng-template>
        </p-messages>
        </div>
        
        <div class="field field-required">
          <bpt-dropdown
            label="Delegate To*"
            [options]="userList"
            id="delegateAssignedTo"
            [editable]="false"
            placeholder="Select Users"
            [showClear]="true"
            [showFilter]="true"
            [multiSelect]="true"
            [valueField]="valueField"
            [labelField]="labelField"
            [(ngModel)]="delegatToUpdate.delegateTo"
            (dropdownChange)="onDelegateToChange()"
          >
          </bpt-dropdown>
        </div>
      <ng-template pTemplate="footer">
          <p-button appPreventDoubleClick label="Confirm" type="submit" id="confirmButton" (debounceClick)="confirmClick()" class="align-right" >
          </p-button>
          <p-button appPreventDoubleClick label="Cancel" styleClass="p-button-outlined" type="submit" id="confirmationCancelButton" (debounceClick)="cancelClick()" class="align-right" >
          </p-button>
      </ng-template>
    </p-dialog>
  
  </div>
</div>
